import { z } from 'zod'
import { optionalText, requiredText } from '../../../lib/forms/rules'

/**
 * Paydaş/katılımcı ekle/düzenle form şeması (022): nameTr zorunlu; nameEn opsiyonel. Sıra (SORT_INDEX) formda
 * yok — sıralama tablodaki ↑/↓ oklarından yapılır (oluşturmada sona otomatik atanır).
 */
export const stakeholderFormSchema = z.object({
  nameTr: requiredText(),
  nameEn: optionalText(),
})

export type StakeholderFormValues = z.infer<typeof stakeholderFormSchema>
